import getSectionWiseData from "./getSectionData";

function getDataSummary() {
    // processes and returns complete data about all sections as well as overall paper
    
    let math = getSectionWiseData('m');
    let logical = getSectionWiseData('l');
    let computer = getSectionWiseData('c');
    let english = getSectionWiseData('e');

    math.marks = (math.correct * 12) - (math.wrong * 3);
    logical.marks = (logical.correct * 6) - (logical.wrong * 1.5);
    computer.marks = (computer.correct * 8) - (computer.wrong * 2);
    english.marks = (english.correct * 4) - (english.wrong * 1);

    const overall = {
        correct: (math.correct + logical.correct + computer.correct + english.correct),
        wrong: (math.wrong + logical.wrong + computer.wrong + english.wrong),
        attempted: (math.attempted + logical.attempted + computer.attempted + english.attempted),
        marks: (math.marks + logical.marks + computer.marks + english.marks),
    };

    const totalSummary = {
        maths: math,
        logical: logical,
        computer: computer,
        english: english,
        overall: overall,
    }

    return totalSummary;
}

export default getDataSummary;